import script from "./ReportsLinks.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportsLinks.vue?vue&type=script&setup=true&lang=js"

import "./ReportsLinks.vue?vue&type=style&index=0&id=738bbf2d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-738bbf2d"]])

export default __exports__